import { ActivityByProgressDayResponseDto } from "@/data/dto/patient-treatement-detail-list/activity-by-pregress-day-response-dto";
import { ActivityDetailDto } from "@/data/dto/patient-treatement-detail-list/activity-detail-dto";
import { ActivityByProgressDayInfoEntity } from "@/domain/entity/treatment/activity-by-progress-day-info-entity";
import { ActivitySectionEntity } from "@/domain/entity/treatment/activity-detail-entity";
import { formatLocalToHHmm, serverDateToLocalDate } from "@/utils/date-util";
import { getActivityType } from "@/utils/enum/activity-type-enum";

export class ActivityByProgressDayInfoMapper {
  static toEntity(dto: ActivityByProgressDayResponseDto): ActivityByProgressDayInfoEntity {
    const maxSectionIndex = 5; //dto.activities.reduce((max, activity) => Math.max(max, activity.sessionIndex), 0);
    // maxSectionIndex를 0부터 max값까지 돌면서, 각 sessionIndex에 해당하는 activity 배열을 만들고,
    // cycleIndex 기준으로 오름차순 정렬하여 2차원 배열로 만든다.

    // 활동을 enum 타입으로 변경
    const newActivities = dto.activities.map((activity) => ({
      ...activity,
      activityType: getActivityType(activity.type),
    }));

    const activitiesBySessionIndex: Map<number, ActivityDetailDto[]> = new Map();

    for (let i = 0; i <= maxSectionIndex; i++) {
      const filtered = newActivities
        .filter((activity) => activity.sessionIndex === i)
        .sort((a, b) => a.cycleIndex - b.cycleIndex);

      activitiesBySessionIndex.set(i, filtered);
    }

    const newDataArray: ActivitySectionEntity[] = [];
    console.log(
      "[ActivityByProgressDayInfoMapper] :: toEntity :: activitiesBySessionIndex",
      activitiesBySessionIndex
    );

    const keys = Array.from(activitiesBySessionIndex.keys());

    keys.forEach((key) => {
      const session = activitiesBySessionIndex.get(key);
      if (session && session.length > 0) {
        const first = session[0];
        const last = session[session.length - 1];

        const startAt = serverDateToLocalDate(first.startAt);
        const startAtStrRaw = formatLocalToHHmm(startAt) ?? "";
        const startAtStr = startAtStrRaw === "NaN:NaN" ? "" : startAtStrRaw;
        const endAt = serverDateToLocalDate(last.endAt);
        const endAtStrRaw = formatLocalToHHmm(endAt);
        const endAtStr = endAtStrRaw === "NaN:NaN" ? "" : endAtStrRaw;

        const activityDetailData = session?.map((activity) => ({
          activityType: getActivityType(activity.type),
          count: activity.count,
          positions: {
            eyePositions: activity.positions.eyePositions.map((eyePos) => ({
              rT: Math.round(eyePos.rT * 10) / 10, // 소수점 1자리까지
              x: Math.round(eyePos.x * 10000) / 10000, // 소수점 4자리까지
              y: Math.round(eyePos.y * 10000) / 10000, // 소수점 4자리까지
              c: eyePos.c,
            })),
          },
        }));

        console.log("[ActivityByProgressDayInfoMapper] :: toEntity :: key", key);
        newDataArray.push({
          sessionIndex: key,
          startAt: startAtStr,
          endAt: endAtStr,
          activityDetailData: activityDetailData,
        });
      }
    });

    return {
      // progressRawDate: dto.executeStartTime,
      // progressDay: dto.progressDay,
      // state: getActivityState(dto.state),
      // lightEstimationStr: `${dto.lightEstimationCount}/${LIGHT_ESTIMATION_MAX_COUNT}`,
      // executeTimeStr: `${startTimeStr}-${endTimeStr}`,
      activities: newDataArray,
    };
  }
}
